import React from 'react'
import companyInfo from 'constants/companyInfo'

const ContactPhoneOrZalo = ({ label = 'Số điện thoại' }) => {
  if (companyInfo.phoneNumber) {
    return (
      <span>
        {label}: <a href={`tel:${companyInfo.phoneNumber}`}>{companyInfo.phoneNumber}</a>
      </span>
    )
  }

  if (companyInfo.zaloLink) {
    return (
      <a href={companyInfo.zaloLink} target="_blank" rel="noopener noreferrer">
        Liên hệ qua Zalo
      </a>
    )
  }

  return null
}

export default ContactPhoneOrZalo
